
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcPoiData as ObcPoiDataElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-data/poi-data.js';
 
 
 

 
 export const ObcPoiData = createComponent({
   react: React,
   tagName: 'obc-poi-data',
   elementClass: ObcPoiDataElement,
   events: {
     
     onObcPoiDataLayoutChange: 'obc-poi-data-layout-change' as EventName<CustomEvent<void>>,
   }
  });
 
 